<template>

  <div class="list-imei">
     <KTCodePreview v-bind:title="'Danh sách IMEI'"
      > <template v-slot:toolbar
        >
        <div class="row">
          <div>
             <b-dropdown
              size="sm"
              id="dropdown-1"
              right
              > <template slot="button-content"
                > <i
                  style="font-size: 1rem"
                  class="fas fa-cog"
                ></i
                > <span class="font-weight-bolder">Thao tác</span> </template
              > <b-dropdown-item @click="excelModal"
                > <span
                  > <i
                    style="font-size: 1rem"
                    class="far fa-file-excel"
                  ></i
                  > &nbsp; Xuất Excel</span
                > </b-dropdown-item
              > <!-- <b-dropdown-item @click="$bvModal.show('old-imei-instock-modal')">
                <span>
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  &nbsp; Xuất bảng kê máy cũ còn tồn</span
                >
              </b-dropdown-item> --> <b-dropdown-item @click="onClickToPrint"
                > <span
                  > <i
                    style="font-size: 1rem"
                    class="fas fa-print"
                  ></i
                  > &nbsp; In IMEI</span
                > </b-dropdown-item
              > </b-dropdown
            >
          </div>

        </div>
         </template
      > <template v-slot:preview
        > <b-row class="mb-5"
          > <b-col
            > <b-input
              size="sm"
              placeholder="Nhập mã IMEI"
              v-model="search"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input
            > </b-col
          > <b-col
            > <b-input
              size="sm"
              placeholder="Nhập mã, tên sản phẩm"
              v-model="searchProduct"
              append-icon="search"
              single-line
              hide-details
              v-on:keyup.enter="onFilter()"
            ></b-input
            > </b-col
          > <b-col
            > <div class="list-imei-brand-treeselect"
              > <treeselect
                :options="brandTreeselectOptions"
                :multiple="true"
                :searchable="true"
                placeholder="Chọn thương hiệu sản phẩm"
                :match-keys="['id', 'label']"
                :clearable="true"
                openDirection="bottom"
                v-model="selectedBrandIds"
              /> </div
            > </b-col
          > <b-col
            > <treeselect
              :options="filteredCateOptions"
              :multiple="true"
              :searchable="true"
              placeholder="Chọn danh mục sản phẩm"
              :match-keys="['id', 'label']"
              :clearable="true"
              :show-count="true"
              openDirection="bottom"
              v-model="selectedCategories"
            /> </b-col
          > <b-col
            > <Autosuggest
              :model="searchProvider"
              :suggestions="filteredOptionProvider"
              placeholder="nhà cung cấp"
              @select="onSelectedProvider"
              @change="onInputChangeProvider"
              showClear
            /> </b-col
          > </b-row
        > <b-row class="mb-5"
          > <b-col
            >
            <div class="search-col">
               <b-input-group
                > <date-picker
                  placeholder="Từ"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchFromDay"
                ></date-picker
                > </b-input-group
              > <span class="ml-1 mr-1"></span> <b-input-group
                > <date-picker
                  placeholder="Đến"
                  class="form-control form-control-sm"
                  :config="dpConfigs.date"
                  v-model="searchToDay"
                ></date-picker
                > </b-input-group
              >
            </div>
             </b-col
          > <b-col
            > <BDropdownCustom
              v-model="valueStatus"
              :options="filterdOptionStatus"
              :placeholder="'trạng thái'"
              :matchKey="['name']"
              :searchable="true"
              :limit="5"
            /> </b-col
          > <b-col
            > <b-form-select
              class="select-style"
              size="sm"
              v-model="selectedCompany"
              :options="listCompany"
              value-field="id"
              text-field="name"
              > <template v-slot:first
                > <b-form-select-option
                  :value="null"
                  disabled
                  >-- Doanh nghiệp --</b-form-select-option
                > </template
              > </b-form-select
            > </b-col
          > <b-col
            > <Autosuggest
              :model="searchStock"
              :suggestions="filteredOptions"
              placeholder="cửa hàng"
              @select="onSelected"
              @change="onInputChangeStore"
              showClear
            /> </b-col
          > <b-col
            > <Autosuggest
              :model="searchSubProvider"
              :suggestions="filteredOptionSubProvider"
              placeholder="nhà cung cấp phụ"
              @select="onSelectedSubProvider"
              @change="onInputChangeSubProvider"
              showClear
            /> </b-col
          > </b-row
        > <b-row class="mb-5"
          > <b-col md="1"
            > <b-button
              style="fontweight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter"
              >Lọc</b-button
            > </b-col
          > <b-col
            >
            <div class="d-flex justify-content-end">

              <p
                class="mt-3 text-dark"
                style="font-weight: 500; font-size: 13px"
              >
                 {{ fromNo }} - {{ toNo }} / {{ convertPrice(totalItem) }}
              </p>

            </div>
             </b-col
          > </b-row
        > <b-table
          :items="listImeis"
          :fields="fields"
          bordered
          hover
          responsive
          table-class="list-imei-table"
          :busy="onLoading"
          > <template v-slot:table-busy
            > <vcl-table
              :speed="5"
              :animate="true"
              :columns="8"
            ></vcl-table
            > </template
          > <template v-slot:head(selected)
            > <span
              > <b-form-checkbox
                v-model="checkAllPro"
                @change="checkAll"
                size="lg"
              ></b-form-checkbox
              > </span
            > </template
          > <template v-slot:cell(selected)="row"
            >
            <div class="d-flex justify-content-center">
               <b-form-checkbox
                size="lg"
                v-model="row.item.selected"
                @change="clickIndex"
              ></b-form-checkbox
              >
            </div>
            </template>
          <template v-slot:cell(productName)="row">
            <ProductCommonInfo :product="row.item" />
          </template>
          <template v-slot:cell(provider)="row">
            <span v-b-tooltip.hover :title="'Nhà cung cấp'" v-text="row.item.providerName"></span>
            <div v-if="row.item.importDate">
              <small
                v-b-tooltip.hover
                :title="'Ngày nhập'"
                v-text="row.item.importDate"
                style="white-space: normal; color: blue"
              ></small>
            </div>
            <hr v-if="row.item.subProviderName || row.item.subProviderCode" />
            <div v-if="row.item.subProviderName || row.item.subProviderCode">
              <div v-if="row.item.subProviderName">
                <span v-b-tooltip.hover :title="'Tên NCC phụ'" v-text="row.item.subProviderName"></span>
              </div>
              <div v-if="row.item.subProviderCode">
                <small
                  class="text-warning"
                  v-b-tooltip.hover
                  :title="'Mã NCC phụ'"
                  v-text="row.item.subProviderCode"
                ></small>
              </div>
            </div>
          </template>
          <template v-slot:cell(imeiCode)="row">
            <div class="list-imei-imei-cell">
              <div class="d-flex align-items-center gap-2 flex-wrap">
                <div
                  class="imeiCode flex-grow-1"
                  @click="linkToImeiHistory(row.item)"
                  style="cursor: pointer"
                >
                   <span v-text="row.item.imeiCode"></span>
                </div>
                 <b-button
                  variant="link"
                  class="p-0 copy-imei-btn"
                  @click.stop="copyImeiToClipboard(row.item.imeiCode)"
                  v-b-tooltip.hover
                  title="Copy IMEI"
                  style="min-width: auto; padding: 0 4px !important"
                  > <i
                    class="fas fa-copy text-primary"
                    style="font-size: 0.875rem"
                  ></i
                  > </b-button
                > <span
                  v-if="row.item.companyCode"
                  class="badge badge-pill company-code-badge"
                  :style="{
                    backgroundColor: getCompanyCodeColor(row.item.companyCode),
                    color: '#fff',
                  }"
                  > {{ row.item.companyCode }} </span
                >
              </div>
              <div class="list-imei-imei-meta">
                <div class="list-imei-meta-row">
                  <span class="list-imei-meta-label">Tuổi kho HT:</span>
                  <span
                    v-b-tooltip.hover.right
                    :title="`Tuổi kho hệ thống: ${row.item.storageTimeNum ?? 'N/A'} ngày`"
                    class="list-imei-meta-value"
                    >{{ row.item.storageTimeNum ?? 'N/A' }}</span
                  >
                </div>
                <div class="list-imei-meta-row">
                  <span class="list-imei-meta-label">Tuổi kho CH:</span>
                  <span
                    v-b-tooltip.hover.right
                    :title="`Tuổi kho cửa hàng: ${row.item.receiptDateNum ?? 'N/A'} ngày`"
                    class="list-imei-meta-value"
                    >{{ row.item.receiptDateNum ?? 'N/A' }}</span
                  >
                </div>
              </div>
            </div>
             </template
          > <template v-slot:cell(status)="row"
            >
            <div class="list-imei-status-cell">
               <span
                v-text="checkStatus(row.item.status)"
                class="list-imei-status-label label font-weight-bold label-lg label-inline"
                v-bind:class="getStatusColor(row.item.status)"
              ></span
              >
            </div>
             </template
          > <template v-slot:cell(saleInfo)="row"
            >
            <div class="list-imei-sale-info">
              <div v-if="row.item.saleDate">
                <small class="text-muted">Ngày bán:</small>
                <span v-text="row.item.saleDate"></span>
              </div>
              <div v-if="row.item.customerName">
                <small class="text-muted">KH:</small>
                <span v-text="row.item.customerName"></span>
              </div>
              <span
                v-if="!row.item.saleDate && !row.item.customerName"
                class="text-muted"
                >—</span
              >
            </div>
             </template
          >
          <template v-slot:cell(priceColumn)="row"
            >
            <div class="list-imei-price-cell">
              <div
                v-if="canViewProductOriginalPrice"
                class="list-imei-price-row"
              >
                <span class="list-imei-price-label">Giá nhập:</span>
                <span
                  class="list-imei-price-value"
                  v-text="convertPrice(row.item.originalPrice)"
                ></span>
              </div>
              <div
                class="list-imei-price-row"
                :class="{
                  'list-imei-price-row--sale': canViewProductOriginalPrice,
                }"
                @mouseover="hoverPriceRowId = row.item.id"
                @mouseleave="hoverPriceRowId = null"
              >
                <span class="list-imei-price-label">Giá bán:</span>
                <span
                  class="list-imei-price-value list-imei-price-value--editable"
                  @click="handleShowPriceModel(row.item)"
                  ><i
                    v-if="hoverPriceRowId === row.item.id"
                    class="fas fa-edit text-primary mr-1"
                  ></i
                  ><span v-text="convertPrice(row.item.sellingPrice)"></span
                ></span>
              </div>
            </div>
             </template
          > <template v-slot:cell(actions)="row"
            >
            <div class="d-flex justify-content-center">
               <b-dropdown
                size="sm"
                id="dropdown-left"
                no-caret
                right
                > <template slot="button-content"
                  > <i
                    style="font-size: 1rem; padding-right: 0px"
                    class="flaticon2-settings"
                  ></i
                  > </template
                > <b-dropdown-item
                  @click="editItem(row.item)"
                  v-if="checkViewOnly()"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon-eye"
                    ></i
                    > &nbsp; Chi tiết sản phẩm </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="editItem(row.item)"
                  v-if="!checkViewOnly()"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="flaticon2-pen"
                    ></i
                    > &nbsp; Chỉnh sửa </span
                  > </b-dropdown-item
                > <b-dropdown-item
                  @click="changeProduct(row.item)"
                  v-if="canChangeProduct(row.item.status)"
                  > <span style="color: #3f4254; font-size: 12px"
                    > <i
                      style="font-size: 1rem"
                      class="fa fa-recycle"
                    ></i
                    > &nbsp; Đổi mã </span
                  > </b-dropdown-item
                > </b-dropdown
              >
            </div>
             </template
          > </b-table
        > <template
          > <b-modal
            v-model="showEditPriceModal"
            hide-footer
            :title="productName"
            > <b-row
              v-if="canViewProductOriginalPrice"
              class="mb-5"
              > <b-col
                > <label
                  class="labelInput"
                  for="inputOriginalPrice"
                  >Giá nhập</label
                > <b-form-input
                  v-model="originalPrice"
                  size="sm"
                  placeholder="Nhập giá nhập"
                  v-mask="mask"
                ></b-form-input
                > </b-col
              > </b-row
            > <b-row class="mb-5"
              > <b-col
                > <label
                  class="labelInput"
                  for="inputSellingPrice"
                  >Giá bán</label
                > <b-form-input
                  v-model="sellingPrice"
                  size="sm"
                  placeholder="Nhập giá bán"
                  v-mask="mask"
                ></b-form-input
                > </b-col
              > </b-row
            > <b-row
              > <b-col
                > <b-button
                  style="fontweight: 600; width: 70px"
                  variant="primary"
                  size="sm"
                  @click="updateProduct"
                  >Lưu</b-button
                > <b-button
                  style="margin-left: 10px; font-weight: 600; width: 70px"
                  variant="secondary"
                  size="sm"
                  @click="handleShowPriceModel"
                  >Hủy</b-button
                > </b-col
              > </b-row
            > </b-modal
          > </template
        > <b-row
          > <b-col
            >
            <p
              class="mt-3 text-dark"
              style="font-weight: 500"
            >
               Tổng số IMEI: {{ convertPrice(totalItem) }}
            </p>
             </b-col
          >
          <div class="d-flex justify-content-end">
             <b-col
              > <b-pagination-nav
                class="custom-pagination"
                v-if="numberOfPage >= 2"
                :link-gen="linkGen"
                :number-of-pages="numberOfPage"
                use-router
                @change="fetchData"
                align="right"
                first-class="page-item-first btn btn-icon btn-sm m-1"
                prev-class="page-item-prev btn btn-icon btn-sm m-1"
                next-class="page-item-next btn btn-icon btn-sm m-1 "
                last-class="page-item-last btn btn-icon btn-sm m-1 "
                page-class="btn btn-icon btn-sm border-0 m-1"
                > <template v-slot:first-text
                  > <span> <i class="ki ki-double-arrow-back icon-xs"></i> </span> </template
                > <template v-slot:prev-text> <i class="ki ki-arrow-back icon-xs"></i> </template>
                <template v-slot:next-text> <i class="ki ki-arrow-next icon-xs"></i> </template>
                <template v-slot:last-text
                  > <span class="text-info"> <i class="ki ki-double-arrow-next icon-xs"></i> </span>
                  </template
                > </b-pagination-nav
              > </b-col
            >
          </div>
           </b-row
        > </template
      > </KTCodePreview
    > <b-modal
      ref="excel-modal"
      hide-footer
      title="Xuất excel danh sách imei"
      id="excel-modal"
      > <v-form
        ref="form"
        lazy-validation
        >
        <div class="mb-4">

          <div class="row">

            <div class="col-6">
               <b-form-group label="Chọn cột cần xuất:"
                > <b-form-radio-group
                  v-model="selectedRowExcel"
                  name="radio-sub-component-1"
                  @change.native="showHeader"
                  > <b-form-radio value="all">Tất cả</b-form-radio> </b-form-radio-group
                > </b-form-group
              > <b-form-group label="Danh sách cần xuất:"
                > <b-form-radio-group
                  v-model="selectedListExcel"
                  name="radio-sub-component-2"
                  > <b-form-radio value="all">Tất cả các trang</b-form-radio> </b-form-radio-group
                > </b-form-group
              >
            </div>

          </div>

        </div>
         <b-button
          style="width: 110px"
          variant="primary"
          size="sm"
          @click="reportClick"
          class="mr-3"
          > <v-icon
            small
            class="text-white"
            v-b-tooltip
            >mdi-download</v-icon
          > <strong>Xuất Excel</strong> </b-button
        > <b-button
          style="width: 100px"
          variant="secondary"
          size="sm"
          @click="$bvModal.hide('excel-modal')"
          > <strong>Hủy</strong> </b-button
        > </v-form
      > </b-modal
    > <b-modal
      ref="old-imei-instock-modal"
      hide-footer
      title="Xuất bảng kê máy cũ"
      id="old-imei-instock-modal"
      > <v-form
        > <b-form-group
          > <label for="list-input-old-imei">Chọn cửa hàng</label> <Autosuggest
            :model="searchStoreForOldImeiList"
            :suggestions="suggestionStoreForOldImeiList"
            @select="onSelectedStoreForOldImeiList"
          /> </b-form-group
        > <b-button
          style="width: 110px"
          variant="primary"
          size="sm"
          @click="reportListOldImeis"
          class="mr-3"
          > <v-icon
            small
            class="text-white"
            v-b-tooltip
            >mdi-download</v-icon
          > <strong>Xuất excel</strong> </b-button
        > <b-button
          style="width: 100px"
          variant="secondary"
          size="sm"
          @click="$bvModal.hide('old-imei-instock-modal')"
          > <strong>Hủy</strong> </b-button
        > </v-form
      > </b-modal
    >
    <ImeiDetailModal
      :show="showDetailModal"
      :imeiIds="selectedImeiIds"
      @hide="showDetailModal = false"
    />

    <transition name="selection-panel-slide">
      <div v-if="selectedImeiIds.length > 0" class="selection-panel">
        <div class="selection-panel-inner">
          <div class="selection-label">
            <i class="fas fa-check-square mr-1"></i>
            Đã chọn <strong>{{ selectedImeiIds.length }}</strong> IMEI:
          </div>
          <div class="selection-tags-wrap">
            <span
              v-for="imeiId in selectedImeiIds"
              :key="imeiId"
              class="selection-tag"
            >
              {{ getImeiLabelById(imeiId) }}
              <i class="fas fa-times ml-1" @click="removeImeiSelection(imeiId)"></i>
            </span>
          </div>
          <div class="selection-actions">
            <b-button
              size="sm"
              variant="outline-secondary"
              class="mr-2"
              @click="clearAllImeiSelection"
            >
              <i class="fas fa-times mr-1"></i>
              Bỏ chọn tất cả
            </b-button>
            <b-button
              size="sm"
              variant="info"
              class="font-weight-bold"
              @click="showDetailModal = true"
            >
              <i class="flaticon-eye mr-1"></i>
              Xem chi tiết
            </b-button>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<style lang="scss">
  .list-imei {
  .labelInput {
    font-weight: 600;
  }
  .productCode:hover {
    text-decoration: underline;
  }

  .inputText {
    width: 22%;
  }

  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }

  .icon:hover {
    background-color: #90c6fc;
  }

  .selectedProClass {
    width: 4%;
    text-align: center;
  }
  .productNameClass {
    width: 20%;
  }
  .productNameNotPriceClass {
    width: 20%;
  }
  .imeiClass {
    width: 18%;
    min-width: 12rem;
    vertical-align: top;
  }

  .list-imei-imei-cell {
    min-width: 0;
    text-align: left;
  }

  .list-imei-imei-meta {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid #ebedf3;
    font-size: 0.8125rem;
    line-height: 1.45;
    text-align: left;
  }

  .list-imei-meta-row {
    margin-bottom: 0.2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .list-imei-meta-label {
    font-weight: 600;
    color: #3f4254;
    margin-right: 0.35rem;
  }

  .list-imei-meta-value {
    color: #5e6278;
  }
  .providerClass {
    width: 15%;
  }
  .storeClass {
    width: 10%;
    align-items: center;
  }
  .listImeiPriceClass {
    width: 13%;
    min-width: 9rem;
    vertical-align: top;
  }

  .list-imei-price-cell {
    font-size: 0.875rem;
    line-height: 1.45;
    text-align: right;
  }

  .list-imei-price-row {
    margin-bottom: 0.25rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: baseline;
    gap: 0.25rem 0.35rem;

    &:last-child {
      margin-bottom: 0;
    }

    &--sale {
      padding-top: 0.35rem;
      margin-top: 0.15rem;
      border-top: 1px solid #ebedf3;
    }
  }

  .list-imei-price-label {
    font-weight: 600;
    color: #3f4254;
    flex: 0 0 auto;
  }

  .list-imei-price-value {
    color: #181c32;
    font-variant-numeric: tabular-nums;

    &--editable {
      cursor: pointer;
    }
  }
  .list-imei-table {
    min-width: 1040px;
  }

  .statusProClass {
    width: 12%;
    min-width: 11.5rem;
    max-width: 16rem;
    text-align: center;
    vertical-align: middle;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
  }

  .list-imei-status-cell {
    max-width: 100%;
    margin: 0 auto;
  }

  /* Badge trạng thái: xuống dòng theo từ, không ép vỡ từng ký tự */
  .list-imei-status-label.label {
    height: auto;
    min-height: auto;
    max-width: 100%;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    text-align: center;
    line-height: 1.35;
  }
  .dropdown-header {
    color: #3699ff !important;
  }
  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: middle;
    border-top: 1px solid #ecf0f3;
  }
  .table.b-table.table-sm
    > thead
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left),
  .table.b-table.table-sm
    > tfoot
    > tr
    > [aria-sort]:not(.b-table-sort-icon-left) {
    background-position: right calc(1.5rem / 2) center;
    padding-right: calc(0.3rem + 0.65em);
  }
  a {
    width: 100%;
  }

  .imeiCode:hover {
    text-decoration: underline;
  }

  .company-code-badge {
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.4rem 0.7rem;
    letter-spacing: 0.3px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    transition: all 0.2s ease;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    line-height: 1;
    flex-shrink: 0;
  }

  .company-code-badge:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.18);
  }

  // Hỗ trợ gap cho các trình duyệt không hỗ trợ
  .d-flex.gap-2 > * + * {
    margin-left: 0.5rem;
  }

  .test {
    position: absolute;
    right: 1vw;
  }
  .checkbox-label {
    display: block;
  }

  .search-col {
    display: flex;
    align-items: center;
  }

  /* Treeselect thương hiệu: một dòng, không nhảy chiều cao — cuộn ngang khi nhiều tag */
  .list-imei-brand-treeselect {
    .vue-treeselect__control {
      min-height: 31px;
      max-height: 31px;
      height: 31px;
      align-items: center;
      padding-top: 0;
      padding-bottom: 0;
    }

    .vue-treeselect__value-container {
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      align-items: center;
      max-height: 100%;
      -webkit-overflow-scrolling: touch;
    }

    .vue-treeselect__multi-value {
      flex-shrink: 0;
      margin-bottom: 0;
    }

    .vue-treeselect__input-container {
      flex-shrink: 0;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>

<script>
  import KTCodePreview from '@/view/content/CodePreview.vue'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import Swal from 'sweetalert2'
  import ApiService from '@/core/services/api.service'
  import localData from '@/utils/saveDataToLocal'
  import permissionMixin from '@/view/mixins/permission.mixin'
  import getPermissionsMixin from '@/view/mixins/get-permissions.mixin'
  import { checkAnyPermission } from '@/utils/permissionUtils'
  import { VclTable } from 'vue-content-loading'
  import {
    currencyMask,
    unMaskPrice,
    xoa_dau,
    removeAccents,
    convertPrice,
    makeToastSuccess,
    makeToastFaile,
    getCompanyCodeColor,
  } from '@/utils/common'
  import axios from 'axios'
  import decounce from 'debounce'
  import { searchCustomers } from '@/utils/customerSearch'
  import { BASE_URL, TIME_TRIGGER } from '@/utils/constants'
  import moment from 'moment'
  import fileDownload from '@/utils/file-download'
  import ProductCommonInfo from '@/view/components/products/ProductCommonInfo.vue'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import ImeiDetailModal from '@/view/components/imeis/ImeiDetailModal.vue'
  import { cloneDeep, map, find, assign } from 'lodash'
  import { getToastInstance } from '@/utils/toastHelper'
  import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    mixins: [permissionMixin, getPermissionsMixin],
    data() {
      return {
        selectedCategories: [],
        selectedInternalCategories: [],
        inputListOldImei: '',
        originalPrice: 0,
        sellingPrice: 0,
        productName: '',
        productId: '',
        hoverPrice: false,
        selectedProvider: null,
        listProvider: [],
        btnCreate: {
          fontWeight: '600!important',
        },
        selected: [],
        checkAllPro: false,
        fields: [
          {
            key: 'selected',
            label: '',
            thStyle: { textAlign: 'center' },
            tdClass: 'selectedProClass',
            thClass: 'selectedProClass',
          },
          {
            key: 'productName',
            label: 'Sản phẩm',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'productNameClass',
            thClass: 'productNameClass',
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'imeiClass',
            thClass: 'imeiClass',
          },
          {
            key: 'provider',
            label: 'NCC/NCC phụ',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'providerClass',
            thClass: 'providerClass',
          },
          {
            key: 'store',
            label: 'Kho',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'storeClass',
            thClass: 'storeClass',
          },
          {
            key: 'saleInfo',
            label: 'Ngày bán / Khách',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'saleInfoClass',
            thClass: 'saleInfoClass',
          },
          {
            key: 'priceColumn',
            label: 'Giá nhập / Giá bán',
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
            tdClass: 'listImeiPriceClass',
            thClass: 'listImeiPriceClass',
          },
          {
            key: 'status',
            label: 'Trạng thái',
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              minWidth: '11.5rem',
            },
            tdClass: 'statusProClass',
            thClass: 'statusProClass',
          },
          { key: 'actions', label: '' },
        ],
        search: '',
        listImeis: [],
        listCategories: [],
        selectedCategory: null,
        linkGen: (pageNum) => {
          return pageNum === 1 ? '?' : `?page=${pageNum}`
        },
        page: 1,
        totalItem: 0,
        listStatus: [
          { id: '', name: 'Tất cả trạng thái' },
          { id: 1, name: 'Mới' },
          { id: 2, name: 'Đã bán' },
          { id: 3, name: 'Đang vận chuyển' },
          { id: 4, name: 'Lỗi' },
          { id: 5, name: 'Đã trả NCC' },
          { id: 6, name: 'Đang chuyển kho' },
          { id: 7, name: 'Đã trả bảo hành' },
          { id: 8, name: 'Đang bảo hành' },
          { id: 9, name: 'Đang giữ hàng' },
          { id: 10, name: 'Đang cho mượn' },
        ],
        onLoading: false,
        numberOfPage: 0,
        filteredOptions: [],
        suggestionStoreForOldImeiList: [],
        optionsStore: [
          {
            data: [],
          },
        ],
        searchProduct: '',
        showEditPriceModal: false,
        mask: currencyMask,
        listStore: [],
        selectedStore: null,
        selectedStoreForOldImeiList: null,
        searchStock: '',
        searchStoreForOldImeiList: '',
        selectedRowExcel: 'all',
        selectedListExcel: 'all',
        showHeaderExcel: false,
        indeterminate: false,
        filteredOptionProvider: [],
        optionsProvider: [
          {
            data: [],
          },
        ],
        searchProvider: '',
        selectedSubProvider: null,
        searchSubProvider: '',
        filteredOptionSubProvider: [{ id: null, name: 'Tất cả' }],
        fromNo: 0,
        toNo: 0,
        LIMIT_PAGE: 30,
        cateOptions: [
          {
            data: [],
          },
        ],
        filteredCateOptions: [],
        brandTreeselectOptions: [],
        selectedBrandIds: [],
        selectedCateId: null,
        cate2Options: [
          {
            data: [],
          },
        ],
        selectedCate2Id: null,
        dpConfigs: {
          date: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        searchFromDay: '',
        searchToDay: '',
        valueStatus: [],
        optionsStatus: [
          {
            code: 1,
            name: 'Mới',
            shortName: 'Mới',
            checked: false,
          },
          {
            code: 2,
            name: 'Đã bán',
            shortName: 'Đã bán',
            checked: false,
          },
          {
            code: 3,
            name: 'Đang vận chuyển',
            shortName: 'Đang vận chuyển',
            checked: false,
          },
          {
            code: 4,
            name: 'Lỗi',
            shortName: 'Lỗi',
            checked: false,
          },
          {
            code: 5,
            name: 'Đã trả NCC',
            shortName: 'Đã trả NCC',
            checked: false,
          },
          {
            code: 6,
            name: 'Đang chuyển kho',
            shortName: 'Đang chuyển kho',
            checked: false,
          },
          {
            code: 7,
            name: 'Đã trả bảo hành',
            shortName: 'Đã trả bảo hành',
            checked: false,
          },
          {
            code: 8,
            name: 'Đang bảo hành',
            shortName: 'Đang bảo hành',
            checked: false,
          },
          {
            code: 9,
            name: 'Đang giữ hàng',
            shortName: 'Đang giữ hàng',
            checked: false,
          },
          {
            code: 10,
            name: 'Đang cho mượn',
            checked: false,
          },
          {
            code: 11,
            name: 'Đang sửa chữa',
            checked: false,
          },
        ],
        filterdOptionStatus: [],
        selectedCompany: null,
        listCompany: [],
        showDetailModal: false,
      }
    },
    computed: {
      selectedImeiIds() {
        return this.listImeis
          .filter((item) => item.selected)
          .map((item) => item.id)
      },
      canViewProductOriginalPrice() {
        return checkAnyPermission(this.listPermission, [
          'productOriginalPriceView',
          'PRODUCT_ORIGINAL_PRICE_VIEW',
        ])
      },
    },
    components: {
      KTCodePreview,
      VclTable,
      Autosuggest,
      BDropdownCustom,
      Treeselect,
      ProductCommonInfo,
      ImeiDetailModal,
    },
    watch: {
      listPermission: {
        handler() {
          this.checkViewOriginalPrice()
        },
        deep: true,
      },
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'IMEI', route: '/imeis' },
        { title: 'Danh sách IMEI' },
      ])
    },
    created() {
      let imeiCode = this.$route.query.code
      let searchProduct = this.$route.query.searchProduct
      let storeId = this.$route.query.storeId
      if (imeiCode !== undefined) {
        this.search = imeiCode
      }
      if (searchProduct !== undefined) {
        this.searchProduct = searchProduct
      }
      if (storeId !== undefined) {
        this.selectedStore = storeId
      }
      this.fetchData()
      this.fetchProvider()
      this.checkViewOriginalPrice()
      this.fetchStore()
      this.fetchCategory()
      this.fetchBrands()
      this.fetchCompany()
    },
    methods: {
      getStatusColor(status) {
        const MAP_COLOR = {
          1: 'label-light-warning',
          2: 'label-light-success',
          3: 'label-light-danger',
          4: 'label-light-default',
          10: 'label-light-info',
        }

        return MAP_COLOR[status] || 'label-light-default'
      },
      convertPrice,
      ...getToastInstance(),
      checkStatus: function (item) {
        switch (item) {
          case 1:
            return 'Mới'
          case 2:
            return 'Đã bán'
          case 3:
            return 'Đang vận chuyển'
          case 4:
            return 'Lỗi'
          case 5:
            return 'Đã trả NCC'
          case 6:
            return 'Đang chuyển kho'
          case 7:
            return 'Đã trả bảo hành'
          case 8:
            return 'Đang bảo hành'
          case 9:
            return 'Đang giữ hàng'
          case 10:
            return 'Đang cho mượn'
          case 11:
            return 'Đang sửa chữa'
          default:
            return ''
        }
      },
      checkViewOnly: function () {
        let count = 0
        if (localData.checkPermission('PRODUCT_VIEW')) {
          count++
        }
        if (localData.checkPermission('PRODUCT_UPDATE')) {
          count++
        }
        if (count === 1) {
          return true
        } else {
          return false
        }
      },
      canChangeProduct(imeiStatus) {
        return imeiStatus === 1
      },
      showDeleteAlert: function (item) {
        Swal.fire({
          title: 'Xóa sản phẩm!',
          text: 'Bạn có chắc muốn xóa sản phẩm này không ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(221, 51, 51)',
          cancelButtonColor: '#E5EAEE',
          confirmButtonText: 'Xóa',
          cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
          reverseButtons: true,
          position: 'top',
        }).then((result) => {
          if (result.value) {
            this.deleteItem(item)
          }
        })
      },
      deleteItem: function (item) {
        alert(item)
      },
      fetchData: function () {
        this.onLoading = true
        this.page = this.$route.query.page
        if (!this.page) {
          this.page = 1
        }
        if (this.searchStock.trim() === '') {
          this.selectedStore = null
        }
        let listStatus = []
        if (this.valueStatus.length) {
          listStatus = this.valueStatus.map(({ code }) => code)
        }
        this.filterdOptionStatus = cloneDeep(this.optionsStatus)
        const param = {
          page: this.page,
          limit: this.LIMIT_PAGE,
          status: listStatus,
          search: this.search ? this.search.trim() : '',
          providerId: this.selectedProvider,
          subProviderId: this.selectedSubProvider,
          searchProduct: this.searchProduct,
          storeId: this.selectedStore,
          companyId: this.selectedCompany,
          fromDate: this.searchFromDay
            ? moment(this.searchFromDay, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : null,
          toDate: this.searchToDay
            ? moment(this.searchToDay, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : null,
          cateId: this.selectedCategories,
          brandIds: this.selectedBrandIds,
        }
        const paramQuery = {
          params: param,
        }
        ApiService.query('imeis', paramQuery)
          .then(({ data }) => {
            this.listImeis = []
            this.numberOfPage = data.data.total_page
            this.totalItem = data.data.total_row
            this.fromNo = (this.page - 1) * this.LIMIT_PAGE + 1
            this.toNo = this.LIMIT_PAGE * this.page
            if (this.toNo > this.totalItem) {
              this.toNo = this.totalItem
            }
            data.data.list_imei.forEach((element) => {
              const item = {
                id: element.id,
                productId: element.productId,
                barCode: element.barCode,
                productCode: element.productCode,
                productName: element.productName,
                imeiCode: element.imeiCode,
                companyCode: element.companyCode,
                companyName: element.companyName,
                provider: element.providerName,
                providerName: element.providerName,
                subProviderName: element.subProviderName,
                subProviderCode: element.subProviderCode,
                store: element.storeName,
                originalPrice: element.originalPrice,
                sellingPrice: element.sellingPrice,
                status: element.status,
                selected: false,
                importDate: element.importDate,
                saleDate: element.saleDate,
                customerName: element.customerName,
                customerId: element.customerId,
                merchantId: element.merchantId,
                productImageUrl: element.imageUrl,
                storageTimeNum: element.storageTimeNum,
                receiptDateNum: element.receiptDateNum,
              }
              this.listImeis.push(item)
            })
            this.onLoading = false
          })
          .catch((error) => {
            this.onLoading = false
            if (error.response) {
              makeToastFaile(error.response.data ? error.response.data.message : 'Lỗi')
            } else {
              makeToastFaile(error.message || 'Lỗi')
            }
          })
      },
      editItem: function (item) {
        this.$router.push({
          name: 'update-imei',
          query: { id: item.id },
        })
      },
      changeProduct: function (item) {
        this.$router.push({
          name: 'production-order',
          query: { imeiId: item.id, tab: 'change-product' },
        })
      },
      fetchProvider() {
        const noneOption = { id: null, name: 'Tất cả' }
        this.filteredOptionProvider = [noneOption]
      },
      onSelected(option) {
        this.searchStock = option.item.name
        this.selectedStore = option.item.id
        this.onFilter()
      },
      async reportListOldImeis() {
        await axios({
          url: `${BASE_URL}stocks/export-list-old-imeis?storeIds=${this.selectedStoreForOldImeiList}`,
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          const fileName = fileDownload.getFileName(response)
          fileDownload.createFile(response.data, fileName)
        })
      },
      async reportOutstockOldImeiList() {
        await axios({
          url: `${BASE_URL}stocks/export-list-outstock-old-imeis`,
          method: 'POST',
          responseType: 'blob',
          data: {
            listImeis: this.inputListOldImei,
          },
        }).then((response) => {
          const fileName = fileDownload.getFileName(response)
          fileDownload.createFile(response.data, fileName)
        })
      },
      onSelectedStoreForOldImeiList(option) {
        this.searchStoreForOldImeiList = option.item.name
        this.selectedStoreForOldImeiList = option.item.id
      },
      onInputChangeStore(text) {
        if (!text) {
          text = ''
        }
        this.searchStock = text

        /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
        const filteredData = this.optionsStore[0].data.filter((item) => {
          return (
            item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
          )
        })

        this.filteredOptions = [...filteredData]
      },
      getSuggestionValue(suggestion) {
        return suggestion.item.name
      },
      handleShowPriceModel(item) {
        this.showEditPriceModal = !this.showEditPriceModal
        this.productId = item.id
        this.productName = item.productName
        this.originalPrice = item.originalPrice
        this.sellingPrice = item.sellingPrice
      },
      updateProduct: async function () {
        const data = {
          id: this.productId,
          sellingPrice: unMaskPrice(this.sellingPrice),
        }
        if (this.canViewProductOriginalPrice) {
          data.originalPrice = unMaskPrice(this.originalPrice)
        }
        await ApiService.put('imeis/update-price', data)
          .then(({ data }) => {
            if (data.status === 1) {
              this.fetchData()
              this.showEditPriceModal = !this.showEditPriceModal
              makeToastSuccess(data.message)
            } else {
              this.fetchData()
              this.showEditPriceModal = !this.showEditPriceModal
              makeToastFaile(data.message)
            }
          })
          .catch(({ response }) => {
            const { status, message } = response.data
            if (status === 0) {
              makeToastFaile(message)
            }
          })
      },
      linkToImeiHistory: function (item) {
        const { href } = this.$router.resolve({
          name: 'list-imei-history',
          query: { code: item.imeiCode },
        })
        window.open(href, '_blank')
      },
      copyImeiToClipboard: async function (imeiCode) {
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(imeiCode)
            makeToastSuccess('Đã copy IMEI: ' + imeiCode)
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea')
            textArea.value = imeiCode
            textArea.style.position = 'fixed'
            textArea.style.left = '-999999px'
            document.body.appendChild(textArea)
            textArea.select()
            document.execCommand('copy')
            document.body.removeChild(textArea)
            makeToastSuccess('Đã copy IMEI: ' + imeiCode)
          }
        } catch (err) {
          makeToastFaile('Không thể copy IMEI')
        }
      },
      getCompanyCodeColor,
      excelModal: async function () {
        this.$refs['excel-modal'].show()
      },
      reportClick: async function () {
        this.processBar = 0
        const listStatus = this.valueStatus.map((element) => element.code)

        const params = {
          status: listStatus,
          search: this.search,
          providerId: this.selectedProvider,
          subProviderId: this.selectedSubProvider,
          searchProduct: this.searchProduct,
          storeId: this.selectedStore,
          fromDate: this.searchFromDay
            ? moment(this.searchFromDay, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : null,
          toDate: this.searchToDay
            ? moment(this.searchToDay, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : null,
          cateId: this.selectedCategories,
          brandIds: this.selectedBrandIds,
        }

        try {
          const response = await ApiService.get('productImeiStock/export-excel', {
            params,
            responseType: 'blob',
          })

          const contentType = String(response.headers['content-type'] || '').toLowerCase()
          if (contentType.includes('application/json')) {
            const text = await response.data.text()
            let message = 'Xuất Excel thất bại'
            try {
              const json = JSON.parse(text)
              message =
                [json.message, json.error, json.msg].find(
                  (item) => typeof item === 'string' && item.trim(),
                ) || message
            } catch (_) {
              /* ignore */
            }
            makeToastFaile(message)
            return
          }

          let fileName = `DanhSachImei-${moment().format('YYYY-MM-DD_HHmmss')}.xlsx`
          try {
            fileName = fileDownload.getFileName(response)
          } catch (_) {
            /* BE không gửi / CORS không expose Content-Disposition */
          }

          fileDownload.createFile(
            response.data,
            fileName,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          )
          makeToastSuccess('Đã tải file Excel')
        } catch (error) {
          let message = 'Xuất Excel không thành công'
          const blobData = error?.response?.data
          if (blobData instanceof Blob) {
            try {
              const text = await blobData.text()
              const json = JSON.parse(text)
              message =
                [json.message, json.error].find(
                  (item) => typeof item === 'string' && item.trim(),
                ) || message
            } catch (_) {
              /* ignore */
            }
          } else if (error?.message === 'File excel không đúng!') {
            message = 'Không đọc được tên file từ server'
          }
          makeToastFaile(message)
        }
      },
      debounceInput: decounce(function () {
        this.onFilter()
      }, TIME_TRIGGER),
      checkViewOriginalPrice() {
        for (let index = 0; index < this.fields.length; index++) {
          const element = this.fields[index]
          if (element.key === 'productName') {
            if (!this.canViewProductOriginalPrice) {
              this.fields[index].tdClass = 'productNameNotPriceClass'
              this.fields[index].thClass = 'productNameNotPriceClass'
            } else {
              this.fields[index].tdClass = 'productNameClass'
              this.fields[index].thClass = 'productNameClass'
            }
          }
          if (element.key === 'priceColumn') {
            this.$set(
              this.fields[index],
              'label',
              this.canViewProductOriginalPrice ? 'Giá nhập / Giá bán' : 'Giá bán',
            )
          }
        }
      },
      fetchStore: async function () {
        this.optionsStore[0].data = []
        ApiService.get('/stores/getStores').then((response) => {
          const stores = response.data.data
          stores.map((element) => {
            this.optionsStore[0].data.push(element)
          })
          this.filteredOptions = [...this.optionsStore[0].data]
          this.suggestionStoreForOldImeiList = [...this.optionsStore[0].data]
        })
      },
      onFilter() {
        this.$route.query.page = 1
        this.$router.push({
          name: 'list-imeis',
        })
        this.fetchData()
      },
      showHeader() {
        if (this.selectedRowExcel === 'row') {
          this.showHeaderExcel = true
        } else {
          this.showHeaderExcel = false
        }
      },
      onSelectedProvider(option) {
        this.searchProvider = option.item.name
        this.selectedProvider = option.item.id
        this.resetSubProvider()
      },
      onInputChangeProvider(text) {
        this.searchProvider = text || ''
        if (!text || !text.trim()) {
          this.selectedProvider = null
          this.filteredOptionProvider = [{ id: null, name: 'Tất cả' }]
          this.resetSubProvider()
          return
        }
        this.debounceSearchProvider()
      },
      debounceSearchProvider: decounce(async function () {
        const items = await searchCustomers(this.searchProvider)
        const noneOption = { id: null, name: 'Tất cả' }
        this.filteredOptionProvider = [
          noneOption,
          ...items.map((c) => ({ id: c.id, name: c.fullName })),
        ]
      }, TIME_TRIGGER),
      // Xoá lựa chọn NCC phụ khi NCC chính thay đổi (NCC phụ phụ thuộc NCC chính)
      resetSubProvider() {
        this.selectedSubProvider = null
        this.searchSubProvider = ''
        this.filteredOptionSubProvider = [{ id: null, name: 'Tất cả' }]
      },
      onSelectedSubProvider(option) {
        this.searchSubProvider = option.item.name
        this.selectedSubProvider = option.item.id
      },
      onInputChangeSubProvider(text) {
        this.searchSubProvider = text || ''
        if (!text || !text.trim()) {
          this.selectedSubProvider = null
          this.filteredOptionSubProvider = [{ id: null, name: 'Tất cả' }]
          return
        }
        this.debounceSearchSubProvider()
      },
      debounceSearchSubProvider: decounce(async function () {
        // NCC phụ luôn yêu cầu parentId != null: đã chọn NCC chính thì lọc theo parentId,
        // chưa chọn thì dùng onlyChild để chỉ lấy customer có cha (NCC phụ)
        const extraParams = this.selectedProvider
          ? { parentId: this.selectedProvider }
          : { onlyChild: true }
        const items = await searchCustomers(this.searchSubProvider, 10, false, extraParams)
        const noneOption = { id: null, name: 'Tất cả' }
        this.filteredOptionSubProvider = [
          noneOption,
          ...items.map((c) => ({ id: c.id, name: c.fullName })),
        ]
      }, TIME_TRIGGER),
      fetchCategory: function () {
        const param = {
          page: 1,
          limit: 1000,
          name: '',
          code: '',
        }
        const paramQuery = {
          params: param,
        }
        ApiService.query('categories', paramQuery).then(({ data }) => {
          this.filteredCateOptions = data.data.list_caterogy
        })
      },
      fetchBrands: function () {
        const param = {
          page: 1,
          pageSize: 1000,
          name: '',
        }
        ApiService.query('brands', { params: param }).then(({ data }) => {
          const brands = data?.data?.brands ?? data?.brands ?? []
          this.brandTreeselectOptions = brands.map((b) => ({
            id: b.id,
            label: b.name,
          }))
        })
      },
      onInputStatusChange(textInput = '') {
        this.searchStatus(textInput)
      },
      searchStatus(textInput) {
        let options = cloneDeep(this.optionsStatus)
        if (!textInput || !textInput.trim().length) {
          this.filterdOptionStatus = map(options, (obj) => {
            return assign(obj, find(this.filterdOptionStatus, { id: obj.id }))
          })
          return
        }

        const indexChooseAll = options.findIndex((prop) => prop.id === -1)

        if (indexChooseAll > -1) {
          options.splice(indexChooseAll, 1)
        }

        options = map(options, (obj) => {
          return assign(obj, find(this.filterdOptionStatus, { id: obj.id }))
        })

        this.filterdOptionStatus = this.fitlerOptionsBy(options, textInput, 'name', 10)
      },
      fitlerOptionsBy(items, textInput, prop, limit) {
        return cloneDeep(items)
          .filter((item) => {
            if (item) {
              const nameWTUnicode = removeAccents(item[prop] || '')
              const nameInputWTUnicode = removeAccents(textInput)
              const index = nameWTUnicode.toLowerCase().indexOf(nameInputWTUnicode.toLowerCase())

              if (index > -1) {
                return true
              }
            }
            return false
          })
          .slice(0, limit)
      },
      onSelectStatus(option) {
        const index = this.optionsStatus.findIndex((item) => item.name == option.name)
        this.optionsStatus[index].checked = true
        this.filterdOptionStatus = cloneDeep(this.optionsStatus)
      },
      onRemoveStatus(option) {
        const index = this.optionsStatus.findIndex((item) => item.name == option.name)
        this.optionsStatus[index].checked = false
        this.filterdOptionStatus = cloneDeep(this.optionsStatus)
      },
      customLabelStatus(option) {
        return `${option.name}`
      },
      checkAll() {
        this.listImeis.forEach((element) => {
          element.selected = this.checkAllPro
        })
      },
      fetchCompany: async function () {
        this.listCompany = []
        ApiService.get('/v1/companies/all').then((response) => {
          this.listCompany = response.data.data
          this.listCompany.unshift({
            id: null,
            name: 'Tất cả',
          })
        })
      },
      clickIndex() {
        if (this.checkAllPro == true) {
          this.checkAllPro = false
        } else {
          var count = 0
          this.listImeis.forEach((element) => {
            if (element.selected == true) {
              count += 1
              if (count == 10) {
                this.checkAllPro = true
              }
            }
          })
        }
      },
      onClickToPrint() {
        const { href } = this.$router.resolve({
          name: 'print-imei',
        })
        window.open(href, '_blank')
      },
      getImeiLabelById(id) {
        const imei = this.listImeis.find((item) => item.id === id)
        return imei ? imei.imeiCode : id
      },
      removeImeiSelection(id) {
        const imei = this.listImeis.find((item) => item.id === id)
        if (imei) {
          imei.selected = false
        }
        this.checkAllPro = false
      },
      clearAllImeiSelection() {
        this.listImeis.forEach((item) => {
          item.selected = false
        })
        this.checkAllPro = false
      },
    },
  }
</script>

<style scoped>
.selection-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1050;
  background: #fff;
  border-top: 2px solid #3699ff;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.12);
  padding: 10px 24px;
}

.selection-panel-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: 1400px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.selection-label {
  white-space: nowrap;
  font-size: 0.88rem;
  color: #464e5f;
  flex-shrink: 0;
}

.selection-tags-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  min-width: 0;
  max-height: 60px;
  overflow-y: auto;
}

.selection-tag {
  display: inline-flex;
  align-items: center;
  background: #e8f4ff;
  border: 1px solid #3699ff;
  color: #0056b3;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 0.82rem;
  font-weight: 600;
  white-space: nowrap;
}

.selection-tag i {
  font-size: 0.7rem;
  cursor: pointer;
  opacity: 0.6;
}

.selection-tag i:hover {
  opacity: 1;
}

.selection-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
}

.selection-panel-slide-enter-active,
.selection-panel-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.selection-panel-slide-enter,
.selection-panel-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>

